<div class="p-d-flex p-flex-column p-jc-between" [ngStyle]="{'min-height': this.height }">
  <div>
    <dum-header-private [user]="userLogged"></dum-header-private>
    <div class="p-col-12 header-title" style="text-align: right;">
      <h2 style="margin-top: 0; margin-bottom: 0;">DUMinVAL</h2>
    </div>
    <dum-menu></dum-menu>
    <dum-content >
      <div class="p-d-flex" >
        <div class="p-col-2" *ngIf="accessChecker.isGranted('view', 'menu-privado') |async">
          <dum-private-menu></dum-private-menu>
        </div>
        <div class="p-col-10 m-auto">
          <ng-content></ng-content>
        </div>
      </div>
    </dum-content>
  </div>


    <dum-footer></dum-footer>
  </div>


